import { render } from "./promotionModal.vue?vue&type=template&id=66a28e60&scoped=true"
import script from "./promotionModal.vue?vue&type=script&lang=js"
export * from "./promotionModal.vue?vue&type=script&lang=js"

import "./promotionModal.vue?vue&type=style&index=0&id=66a28e60&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a28e60"]])

export default __exports__